import { inject, Pipe, PipeTransform } from '@angular/core';
import { ImageSrcService } from './image-src.service';

@Pipe({
  name: 'appImageDataUrl'
})
export class ImageDataUrlPipe implements PipeTransform {

  private imageSrcService: ImageSrcService;

  constructor() {
    this.imageSrcService = inject(ImageSrcService);
  }

  public transform(imageUrl: string, withCache = true): Promise<string> {
    return this.imageSrcService.loadImage(imageUrl, withCache).toPromise();
  }
}
